import { render, staticRenderFns } from "./post_name.vue?vue&type=template&id=165cbe58&scoped=true"
import script from "./post_name.vue?vue&type=script&lang=ts"
export * from "./post_name.vue?vue&type=script&lang=ts"
import style0 from "./post_name.vue?vue&type=style&index=0&id=165cbe58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165cbe58",
  null
  
)

export default component.exports